/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  // Agregamos iconos para el botón
} from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons'; // Icono para los periodos

import { formatReceivedValues } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import ModalSolicitudesPercepcionesEmpleados from 'components/Nominas/SolicitudesPercepciones/ModalSolicitudesPercepcionesEmpleados';
// IMPORTAMOS EL NUEVO MODAL

import currencyFormatter from 'utils/currencyFormatter';
import {
  getEstadosGlobales,
} from 'api/catalogos/index';
import {
  getSolicitudesPercepcionesEmpleados,
  deleteSolicitudPercepcionEmpleado,
} from 'api/nominas/solicitudes/solicitudesPercepcionesEmpleados';
import { getEmpleadosWithoutFilter } from 'api/estructuraOrganizacional/empleados';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { getDatosDePagoDeEmpleados } from 'api/estructuraOrganizacional/datosDePagoDeEmpleados';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPuestos } from 'api/catalogos/puestos';
import { checkToken } from 'api/utils';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import ModalAgregarPeriodosDevolucion from 'components/Nominas/SolicitudesPercepciones/ModalDevolucionDescuentos';

export const solicitudesPercepcionesEmpleadosPermission = {
  permissionModel: 'solicitudpercepcionempleado',
  catalogsModels: [],
  tabsModels: [],
};

const SolcitudesPercepcionesEmpleadosDevolucion = ({
  permission,
  datosOperacionales,
  selected,
  tipoParametro,
  disableColumn,
  disableImportePagar,
  percepcion,
  allowControls,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  // MODAL 1: Selección de empleados
  const [open, setOpen] = useState(false);

  // MODAL 2: Gestión de Periodos (Nuevo)
  const [openPeriodo, setOpenPeriodo] = useState(false);
  const [empleadoParaPeriodos, setEmpleadoParaPeriodos] = useState(null);

  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [formasDePagos, setFormasDePagos] = useState([]);
  const [metodosDePago, setMetodosDePago] = useState([]);
  const [esPercepcionFijo, setEsPercepcionFijo] = useState(false);
  const [importeSolicitudPagar, setImporteSolicitudPagar] = useState();
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);

  // ... (Tus funciones formatReceivedClone y formatReceivedCloneEmpleados se mantienen igual) ...
  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        numero_empleado: e?.empleado,
        nombre_empleado: e?.empleado,
        puesto_empleado: e?.empleado,
        area_empleado: e?.empleado,
        forma_de_pago_empleado: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formatReceivedCloneEmpleados = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        no_y_nombre_empleado: `${e?.numero_de_empleado} - ${e?.nombre} ${e?.apellido_paterno} ${e?.apellido_materno || ''}`,
        tipo_nomina_empleado: selected?.tipo_de_nomina_empleado,
        area: e?.id,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSolicitudesPercepcionesEmpleados({ solicitud_percepcion: selected?.id });
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  // ... (useEffect se mantiene igual) ...
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _empleados,
        _adminPlazas,
        _plazas,
        _puestos,
        _formasDePago,
        _metodosDePago,
        _periodosNominasDetalles,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getEmpleadosWithoutFilter(),
        getAdministracionDePlazasvistaOptimized(),
        getPlazasvistaOptimized(),
        getPuestos(),
        getDatosDePagoDeEmpleados(),
        getMetodosDePagos(),
        getPeriodosDeNominasDetalles(),
        getSolicitudesPercepcionesEmpleados({ solicitud_percepcion: selected?.id }),
      ]);

      if (mounted) {
        setEstados(_estados);
        setEmpleados(formatReceivedCloneEmpleados(_empleados));
        setAdminPlazas(_adminPlazas);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setFormasDePagos(_formasDePago);
        setMetodosDePago(_metodosDePago);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    if (selected?.id) {
      fetchAll();
    }
    return () => { mounted = false; };
  }, [selected?.id]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setOpen(false);
    setOpenPeriodo(false);
    form.resetFields();
  };

  // ... (deleteItem se mantiene igual) ...
  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteSolicitudPercepcionEmpleado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setOpen(true);
  };

  // Lógica del botón para abrir el modal de Periodos
  const onClickAddPeriodo = () => {
    if (selectedRowKeys.length === 0) {
      // Si usas un sistema de notificaciones global, invócalo aquí, si no, un alert simple
      // onInfo('Selecciona un empleado para gestionar sus periodos');
      return;
    }
    const [key] = selectedRowKeys;
    const record = data.find((d) => d.id === key);

    // Enriquecemos la data del empleado para mostrarla bonita en el título del modal
    const empData = empleados.find((e) => e.id === record.empleado);
    const nombreCompleto = empData?.no_y_nombre_empleado || record.nombre_empleado;

    setEmpleadoParaPeriodos({
      ...record,
      nombre_empleado: nombreCompleto,
    });
    setOpenPeriodo(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    // Empleado = "No. - Nombre"
    {
      titleText: 'Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 260,
      render: (val) => {
        const emp = empleados.find((e) => e.id === val);
        return (
          emp?.numero_y_nombre_completo
          || `${emp?.numero_de_empleado} - ${emp?.nombre} ${emp?.apellido_paterno} ${emp?.apellido_materno || ''}`
        );
      },
    },
    // Snapshot histórico congelado al momento de la Solicitud (ver CLAUDE.md
    // "Snapshot histórico de campos cascadeados de Plaza") -- ya NO se resuelve contra
    // adminPlazas/plazas (estado ACTUAL del empleado).
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 220,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 220,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 260,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Periodos de Descuento',
      dataIndex: 'lista_periodos_descripcion',
      key: 'lista_periodos_descripcion',
      width: 250,
      render: (val) => val || '—',
    },

    {
      titleText: 'Importe por Pagar Total',
      dataIndex: 'total_importe_periodos',
      key: 'total_importe_periodos',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          // CONTROLES DE LA TABLA
          controls={{
            onClickAdd, // Botón para agregar empleados
            onClickDelete, // Botón para borrar empleados
          }}
          // BOTONES PERSONALIZADOS
          customActions={[
            {
              onClick: onClickAddPeriodo,
              text: 'Periodos / Importes',
              icon: <UnorderedListOutlined />,
              disabledBySelection: false,
              disabled: selectedRowKeys.length === 0 || !allowControls,
              className: 'primary',
            },
          ]}
          permission={{
            hasAllViewPermission: true,
            add: true,
            change: true,
            delete: true,
          }}
          hasAllViewPermission
          addText="Agregar Empleado"
          deleteText="Quitar Empleado"
          allowExportPDF={false}
          allowAdd={allowControls}
          allowDelete={allowControls}
        />

        {/* MODAL 1: SELECCIONAR EMPLEADOS */}
        <ModalSolicitudesPercepcionesEmpleados
          datosOperacionales={datosOperacionales}
          empleados={empleados}
          solicitud={selected?.solicitud}
          tipoNominaEmpleado={selected?.tipo_de_nomina_empleado}
          periodoNominaDetalle={selected?.periodo_de_nomina_detalle}
          solicitudPercepcion={selected?.id}
          solicitudesPercepcionesEmpleados={data}
          percepcionFijo={esPercepcionFijo}
          importeSolicitudPagar={importeSolicitudPagar}
          tipoParametro={tipoParametro}
          open={open}
          setOpen={setOpen}
          onSave={fetchData}
        />

        {/* MODAL 2: AGREGAR PERIODOS Y IMPORTES AL EMPLEADO SELECCIONADO */}
        {openPeriodo && (
          <ModalAgregarPeriodosDevolucion
            open={openPeriodo}
            onCancel={() => {
              setOpenPeriodo(false); // 1. Cierra el modal
              fetchData(); // 2. Recarga la tabla padre para ver la suma nueva
            }}
            empleadoSelected={empleadoParaPeriodos}
          />
        )}

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Empleado ${empleados.find((e) => e.id === form.getFieldValue('empleado'))?.numero_de_empleado || ''}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default SolcitudesPercepcionesEmpleadosDevolucion;
